// The public contact form (POST /contact). No sign-in, so no Authorization header.
import env from '../config/env'

const FIELD_ERRORS = {
  reason: 'Choose what your message is about.',
  name: 'Shorten your name to 200 characters or fewer.',
  email: 'Enter a valid email address.',
  content_link: 'Shorten the link to 2,000 characters or fewer.',
  message: 'Write a message between 10 and 5,000 characters.'
}
const UNSUPPORTED_CHARACTERS = 'Remove unsupported characters (such as pasted control characters) and try again.'

export class ContactError extends Error {
  constructor (message, status = null) {
    super(message)
    this.name = 'ContactError'
    this.status = status
  }
}

// The API's reason for a refused message, in words a visitor can act on.
export const contactErrorText = (status, detail) => {
  if (typeof detail === 'string' && detail) return detail
  if (Array.isArray(detail)) {
    const messages = [...new Set(detail
      .map(item => String(item?.msg || '').includes('unsupported characters')
        ? UNSUPPORTED_CHARACTERS
        : FIELD_ERRORS[(item?.loc || []).at(-1)])
      .filter(Boolean))]
    if (messages.length) return messages.join(' ')
  }
  if (status === 429) return 'Too many messages were sent. Please wait an hour and try again.'
  return 'Your message was not sent. Please try again in a moment.'
}

export const contactBody = ({ reason, name, email, contentLink, message, website }) => ({
  reason,
  name: name?.trim() || null,
  email: (email || '').trim(),
  content_link: contentLink?.trim() || null,
  message: (message || '').trim(),
  website: website || ''
})

export const submitContactRequest = async (form, { apiUrl = env.apiUrl, fetchImpl = globalThis.fetch } = {}) => {
  let response
  try {
    response = await fetchImpl(`${apiUrl}/contact`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(contactBody(form)),
      cache: 'no-store'
    })
  } catch (_) {
    throw new ContactError('Your message was not sent. Check your connection and try again.')
  }
  if (!response.ok) {
    let detail = null
    try {
      detail = (await response.json())?.detail
    } catch (_) {}
    throw new ContactError(contactErrorText(response.status, detail), response.status)
  }
  return { received: true }
}
